import { API, TOKEN_KEY } from "@/lib/api";

export const TEAL = "var(--st-teal)";
export const TROUBLE = "Copilot is having trouble right now. Try again.";

// POSTs a message and reads the SSE stream; calls onEvent({type: delta|card|tool|done|error, ...}).
export async function streamMessage(hubId, cid, body, onEvent) {
  let res;
  try {
    res = await fetch(`${API}/organizations/${hubId}/copilot/conversations/${cid}/messages`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` },
      body: JSON.stringify(body),
    });
  } catch (_) {
    onEvent({ type: "error", message: TROUBLE });
    return;
  }
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    onEvent({ type: "error", message: typeof d.detail === "string" ? d.detail : d.detail?.message || TROUBLE, status: res.status, detail: typeof d.detail === "object" ? d.detail : null });
    return;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let ended = false;
  for (;;) {
    const { value, done } = await reader.read().catch(() => ({ done: true }));
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    parts.forEach((p) => {
      const line = p.split("\n").find((l) => l.startsWith("data: "));
      if (!line) return;
      const ev = JSON.parse(line.slice(6));
      if (ev.type === "done" || ev.type === "error") ended = true;
      onEvent(ev);
    });
  }
  if (!ended) onEvent({ type: "error", message: TROUBLE });
}
